import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const HeaderTitle = styled.div`
  ${typographyV2.titleLg};
  padding: 16px 8px;
`;
